import React, { PureComponent } from "react";
import { connect } from "react-redux";
import FilterPanel from "../components/FilterPanel";
import { resetFilterWithoutPhone } from "../actions/filter";
import { resetHasChangedFilters } from "../actions/componentStatus/hasChangedFilters";

class FilterPanelContainer extends PureComponent {
  render() {
    const {
      clientConfig,
      offerExtraGroups,
      offerExtraIds,
      offerType,
      resetFilterWithoutPhone
    } = this.props;

    return (
      <FilterPanel
        clientConfig={clientConfig}
        offerExtraGroups={offerExtraGroups}
        offerExtraIds={offerExtraIds}
        offerType={offerType}
        onResetClick={resetFilterWithoutPhone}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    clientConfig: state.clientConfig,
    offerExtraGroups: state.portalData.entities.offerExtraGroups.byId,
    offerExtraIds:
      state.portalData.entities.offerExtras[`${state.offerType}Ids`],
    offerType: state.offerType,
    portalId: state.portalId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetFilterWithoutPhone: (offerType, clientConfig) => {
      dispatch(resetFilterWithoutPhone(offerType, clientConfig));
    },
    resetHasChangedFilters: () => {
      dispatch(resetHasChangedFilters());
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { resetFilterWithoutPhone, resetHasChangedFilters } = dispatchProps;
  const { clientConfig, offerType } = stateProps;

  return {
    ...stateProps,
    resetFilterWithoutPhone: () => {
      resetFilterWithoutPhone(offerType, clientConfig);
      resetHasChangedFilters();
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(FilterPanelContainer);
